/* eslint no-multi-spaces: 0 */

import Vue         from 'vue'
import shell       from '@/components/Layouts/shell'
import publicShell from '@/components/Layouts/shell/public'

import legacyRouter from '@/components/LegacyContainer/legacyRouter'

export default {
  shell: Vue.extend(shell),
  publicShell: Vue.extend(publicShell),
  legacy: legacyRouter
}



// WEBPACK FOOTER //
// ./src/components/ModulesWrapper/index.js